import z from 'zod';
import { libraryDocumentIdValue } from '../../editor-draft/value-objects/ids';
import { editorLawTypeValue } from '../../shared/lawTypesContants';
import { firmIdValue, userIdValue, } from '../../subscription/value-objects/ids';
import { firmDocumentTemplateIdValue } from '../value-objects/ids';
export const firmDocumentTemplateSchema = z.object({
    createdAt: z.date(),
    createdByUserId: userIdValue,
    editorHtml: z.string(),
    firmId: firmIdValue,
    id: firmDocumentTemplateIdValue,
    isDefault: z.boolean(),
    isSharedWithFirm: z.boolean(),
    lawType: editorLawTypeValue,
    libraryDocumentId: libraryDocumentIdValue,
    name: z.string().trim().min(1),
    updatedAt: z.date(),
});
export const parseFirmDocumentTemplate = (value) => firmDocumentTemplateSchema.parse(value);
export const isFirmDocumentTemplate = (value) => firmDocumentTemplateSchema.safeParse(value).success;
//# sourceMappingURL=firm-document-template.js.map